<template>
    <div class="QuestionnaireEdit" v-if="init">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="135px" class="demo-ruleForm">
            <div class="activityMsgBox">
                <div class="title"><p>基本属性</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="问卷名称" prop="name" >
                            <el-input v-model.trim="item.name" maxlength="15" show-word-limit  placeholder="输入问卷名称" :disabled="isView"></el-input>
                        </el-form-item>
                        <el-form-item label="问卷描述" prop="desp" >
                            <el-input type="textarea" v-model="item.desp" maxlength="50" show-word-limit  placeholder="输入问卷描述" :disabled="isView"></el-input>
                        </el-form-item>
                        <el-form-item label="背景图" class="cover" prop="coverid">
                            <div class="imgBox">
                                <i class="el-icon-picture" v-if="!item.coverurl"></i>
                                <img class="img" v-else :src="item.coverurl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox" v-if="!isView">
                                <el-button @click.native="openDialog">选择文件</el-button>
                                <el-button type="warning" @click="openCoverScrollBox">素材库</el-button>
                                <p>建议尺寸750*420px的JPG、PNG格式，图片小于5M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="回收方式" required class="recovertype">
                            <el-radio-group v-model="item.recovertype" :disabled="isView" @change="setRecovertype">
                                <el-radio :label="1">定量回收</el-radio>
                                <el-radio :label="2">定时回收</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="" prop="maxfillcount" v-if="item.recovertype==1">
                            <div class="mini-input">收集反馈满 <el-input v-model.trim="item.maxfillcount" placeholder="0" :disabled="isView"></el-input> 份时结束</div>
                            <div class="" v-if="item.recovertype==1">
                                <div class="overfilldesp">收集满时提示：<el-input v-model.trim="item.overfilldesp" placeholder="请输入提示" :disabled="isView"></el-input></div>
                                <div class="tc-lightgrey"><i class="tip el-icon-info tc-lightgrey"></i>  在临界值时多人同时在线填写提交可能导致超额回收的情况</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" prop="" class="date-picker" v-if="item.recovertype==2">
                            <el-radio-group v-model="item.recovertimetype" :disabled="isView" @change="setRecovertimetype">
                                <el-radio :label="1">永久有效</el-radio>
                                <el-radio :label="2">固定时间</el-radio>
                                <el-form-item label="" prop="recoverstdtime"v-if="item.recovertimetype==2" ref="recoverstdtime">
                                    <el-date-picker v-model="item.recoverstdtime" type="datetime" placeholder="请选择回收日期" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :disabled="isView"></el-date-picker>
                                </el-form-item>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="每人填写次数" prop="fillcountbyper" class="mini-input">
                            <el-input v-model.trim="item.fillcountbyper" placeholder="输入每人填写次数" :disabled="isView"></el-input> 次（填0为不限制）
                        </el-form-item>
                        <el-form-item label="关联内容">
                            <el-button type="primary" plain @click="handleAddGoods" v-if="!isView">添加商品</el-button>
                            <div class="model-itemBoxs">
                                <div class="model-itemBox" v-for="(obj, index) in item.kmcinfo" :index="index"  :key="index">
                                    <div class="data-list">
                                        <span><img v-lazy="obj.coverurl" alt=""></span>
                                        <span class="text-ellipse data-name">{{obj.kmcname}}</span>
                                    </div>
                                    <div class="kmctypename">{{obj.kmctypename}}</div>
                                    <div class="model-compBtn" v-if="!isView">
                                        <span class="el-icon-error delComp cursor" @click.stop="handleDel(index)"></span>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="right">
                        <quesPreview ref="quesPreview" :item="item"></quesPreview>
                    </div>
                </div>
            </div>
            <div class="shareBox">
                <div class="title"><p>分享信息设置</p></div>
                <div class="contentBox">
                    <el-form-item label="分享图片" class="cover">
                        <div class="imgBox">
                            <i class="el-icon-picture" v-if="!item.shareimageurl"></i>
                            <img class="img" v-else :src="item.shareimageurl + '?' + time" alt="">
                        </div>
                        <div class="uploadFileBox" v-if="!isView">
                            <el-button @click.native="openDialog2">选择文件</el-button>
                            <p>建议尺寸300*300px的JPG、PNG格式，图片小于2M。</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="分享标题">
                        <el-input v-model.trim="item.sharesubject" placeholder="输入分享标题" :disabled="isView"></el-input>
                    </el-form-item>
                    <el-form-item label="分享内容">
                        <el-input v-model.trim="item.sharedesp" placeholder="输入分享内容" :disabled="isView"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="formBox">
                <div class="title"><p>表单设置</p></div>
                <div class="contentBox">
                    <quesnaireFormSetting ref="quesnaireFormSetting" :item="item" @submit="_submit" :time="time"></quesnaireFormSetting>
                </div>
            </div>
            <el-form-item class="btnBox">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm" v-if="!isView">提交</el-button>
            </el-form-item>
        </el-form>
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <ShopLocalCropper :cropperOption="cropperOption2" ref="localCropper2" @setImage="_setImage2" :uploadType="uploadType"></ShopLocalCropper>
        <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="_setImage"></scrollBox>
        <goodsListDialog ref="goodsListDialog" @setCourseQuesList="_setCourseQuesList"></goodsListDialog>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getCommonFormDetail, saveOrUpdateCommonForm} from 'api/operateToolApi'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import ScrollBox from 'base/scrollBox/scrollBox'
import GoodsListDialog from 'views/operateTool/questionnaire/components/goodsListDialog.vue'
import QuesnaireFormSetting from 'views/operateTool/questionnaire/components/quesnaireFormSetting.vue'
import QuesPreview from 'views/operateTool/questionnaire/components/quesPreview.vue'
export default {
    name: 'QuestionnaireEdit',
    data() {
        let validateRecoverstdtime = (rule, value, callback) => {
            if (this.item.recovertype==2&&this.item.recovertimetype==2 && !value) {
                callback(new Error('请选择固定时间'))
            } else {
                callback()
            }
        }
        return {
            item: {
                innerid: '',
                name: '', // 表单名称
                desp: '', // 表单描述
                coverid: '', // 背景图id
                coverurl: 'https://img.capwhale.com/kmc/commonform_cover_default.png', // 背景图url
                recovertype: 1, // 回收方式：1 定量回收 2 定时回收
                maxfillcount: '', // 最多收集份数-定量回收有效 默认为0
                overfilldesp: '表单已经收集够啦，感谢您的关注', // 收集满时提示信息
                recovertimetype: 1, // 定时回收类型：1永久有效 2固定时间回收
                recoverstdtime: '', // 定时回收时间-固定时间截止有效
                fillcountbyper: 1, // 每人填写次数-默认为1
                kmcinfo: [], // 关联内容信息,json串
                shareimageid: '', // 分享封面id
                shareimageurl: '', // 分享封面url
                sharesubject: '', // 分享标题
                sharedesp: '', // 分享内容
                formlist: [], // 表单信息json
                status: 0
            },
            param: {
                innerid: this.$route.query.innerid ? this.$route.query.innerid : ''
            },
            isView: this.$route.query.isView == 1 ? true : false,
            isCopy: this.$route.query.isCopy == 1 ? true : false,
            time: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [750, 420], // 截图框的宽高比例
                enlarge: 750 / 225, // 图片根据截图框输出比例倍数
                autoCropWidth: 225, // 默认生成截图框宽度
                autoCropHeight: 126 // 默认生成截图框高度
            },
            cropperOption2: {
                fixedNumber: [300, 300], // 截图框的宽高比例
                enlarge: 2, // 图片根据截图框输出比例倍数
                autoCropWidth: 150, // 默认生成截图框宽度
                autoCropHeight: 150 // 默认生成截图框高度
            },
            rules: {
                name: [
                    {required: true, message: '输入问卷名称', trigger: 'blur'}
                ],
                desp: [
                    {required: true, message: '输入问卷名称', trigger: 'blur'}
                ],
                fillcountbyper: [
                    {required: true, message: '输入每人填写次数', trigger: 'blur'}
                ],
                maxfillcount: [
                    {required: true, message: '输入收集份数', trigger: 'blur'}
                ],
                recoverstdtime: [
                    {validator: validateRecoverstdtime, trigger: 'blur'}
                ]
            },
            init: false
        }
    },
    mounted() {
        if (this.param.innerid) {
            this._getView()
        } else {
            this.init = true
        }
    },
    methods: {
        setRecovertype(val) {
            if (this.item.recovertype == 1){
                this.item.maxfillcount = 0
            } else {
                this.item.recovertimetype = 1
            }
            if (this.$refs.recoverstdtime) this.$refs.recoverstdtime.resetField()
            console.log(this.item.recoverstdtime)
        },
        setRecovertimetype(val) {
            if (val == 1) {
                this.$refs.recoverstdtime.resetField()
            }
        },
        handleAddGoods() {
            this.$refs.goodsListDialog.openDialog(this.item.kmcinfo)
        },
        _setCourseQuesList(selectedResult) {
            this.item.kmcinfo = selectedResult
        },
        handleDel(index) {
            this.item.kmcinfo.splice(index, 1)
        },
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.item.coverurl = file.furl
            this.item.coverid = file.key
        },
        openDialog2() {
            this.$refs.localCropper2.openDialog()
        },
        _setImage2(file) {
            this.time = new Date().getTime()
            this.item.shareimageurl = file.furl
            this.item.shareimageid = file.key
        },
        cancel() {
            this.$router.back()
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid, name) => {
                if (valid) {
                    if (!this.item.formlist.length) {
                        this.$message.error('请完成表单设置')
                        return false
                    }
                    this.$refs.quesnaireFormSetting.validate()
                }
            })
        },
        _submit() {
            let obj = $.extend(true, {}, this.item)
            obj.kmcinfo = JSON.stringify(obj.kmcinfo)
            obj.formlist.forEach(o => {
                o.isnotnull = o.isnotnull ? 1 : 0
                delete o.icon
                delete o.typename
                if ([6, 7, 8].indexOf(o.coltype) > -1) {
                    let list = []
                    o.optionsinfo.forEach(oo => {
                        list.push(oo.value)
                    })
                    o.optionsinfo = list.join(',')
                }
            })
            obj.formlist = JSON.stringify(obj.formlist)
            this.$confirm('发布成功后用户可参与问卷调查？', '提示', {
                confirmButtonText: '立即发布',
                cancelButtonText: '暂不发布'
            }).then(() => {
                obj.status = 10
                this._save(obj)
            }).catch(() => {
                this._save(obj)
            })
        },
        _save(obj) {
            this.setLoading(true)
            saveOrUpdateCommonForm({
                data: obj,
                success: data => {
                    this.setLoading(false)
                    this.$message.success('保存成功')
                    this.cancel()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getCommonFormDetail({
                data: Object.assign({}, this.param),
                success: data => {
                    if (this.isCopy) {
                        data.data.innerid = ''
                        data.data.kmcinfo.forEach(obj => {
                            obj.innerid = ''
                        })
                    }
                    data.data.formlist.forEach(obj => {
                        obj.isnotnull = !!obj.isnotnull
                        if (this.isCopy) obj.colinnerid = ''
                        if ([6, 7, 8].indexOf(obj.coltype) > -1) {
                            obj.optionsinfo = obj.optionsinfo.split(',')
                            let list = []
                            obj.optionsinfo.forEach(oo => {
                                list.push({
                                    value: oo,
                                    placeholder: '请输入选择项'
                                })
                            })
                            obj.optionsinfo = list
                        }
                    })
                    data.data.recovertimetype = data.data.recovertimetype ? data.data.recovertimetype : 1
                    this.item = data.data
                    console.log(this.item)
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        ShopLocalCropper, ScrollBox, GoodsListDialog, QuesnaireFormSetting, QuesPreview
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.QuestionnaireEdit {
    background: #F5F7FA;
    min-width: 800px;
    .el-form-item__label {
        line-height: 24px;
        height: 40px;
        display: flex;
        align-items: center;
    }
    .title {
        padding-bottom: 20px;
        border-bottom: 1px solid #DCDFE6;
        p {
            border-left: 2px solid #409EFF;
            text-indent: 8px;
            font-size: 14px;
            font-weight: bold;
        }
    }
    .el-form {
        .el-form-item {
            .el-form-item__label {
                text-align: left;
                font-size: 14px;
            }
        }
    }
    .activityMsgBox {
        .left {
            min-width: 500px;
        }
    }
    .contentBox{
        padding-top: 20px;
        max-width: 1400px;
        .cover {
            .el-form-item__content {
                display: flex;
                align-items: center;
                .imgBox {
                    background: #F5F7FA;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    .el-icon-picture, .el-icon-video-camera-solid {
                        color: #DCDFE6;
                        font-size: 40px;
                    }
                }
                .uploadFileBox {
                    margin-left: 12px;
                    .uploadFile {
                        .upload-demo {
                            .el-upload {
                                .el-button {
                                    background: #fff;
                                    color: #000;
                                    border: 1px solid #C0C4CC;
                                }
                            }
                        }
                    }
                    p {
                        color: #909399;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
    .activityMsgBox {
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;
        .recovertype{
            margin-bottom: 0 !important;
        }
        .contentBox {
            display: flex;
            justify-content: space-between;
            .left {
                min-width: 500px;
                .cover {
                    .imgBox, .img {
                        width: 318px;
                        height: 178px;
                        min-width: 318px;
                    }
                }
                .el-input, input,.el-textarea,textarea{
                    width: 540px !important;
                }
            }
            .disad {
                .el-form-item__label::after {
                    content: '*';
                    color: #F56C6C;
                    margin-left: 4px;
                }
            }
            .el-form-item {
                .el-form-item__content {
                    .el-input {
                        width: 420px;
                    }
                    .el-date-editor {
                        .el-input__icon, .el-range-separator {
                            line-height: 25px;
                        }
                    }
                    .mostTips {
                        color: #C0C4CC;
                    }
                    .showRankingListTips {
                        color: #909399;
                        margin-left: 20px;
                        position: relative;
                        top: 2px;
                    }
                }
            }
            .mini-input{
                .el-input, input{
                    width: 70px !important;
                    min-width: 70px;
                }
            }
            .overfilldesp{
                .el-input, input{
                    width: 280px !important;
                    min-width: 280px;
                }
            }
            .date-picker{
                height: 40px;
                display: flex;
                align-items: center;
                .el-input, input{
                    width: 180px !important;
                    min-width: 180px;
                }
                .el-radio-group {
                    display: flex;
                    align-items: center;
                }
            }
        }
        .right {

        }
    }
    .model-itemBoxs {
        .model-itemBox {
            box-sizing: border-box;
            position: relative;
            font-size: 14px;
            background: #F5F7FA;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            img {
                width: 53px;
                height: 30px;
                display: block;
                min-width: 53px;
            }
            .delComp {
                font-size: 16px;
                margin-right: 10px;
                color: $tcolor-grey;
                left: calc(100% - 10px);
            }
            .data-list {
                @include flexBox(flex-start);
                height: 30px;
                width: 600px;
                span {
                    margin-right: 10px;
                }
                .data-name {
                    max-width: 250px;
                }
            }
            .kmctypename{
                white-space: nowrap;
                margin: 0 15px;
            }
        }
        .model-itemBox + .model-itemBox {
            margin-top: 10px;
        }
    }
    .el-button+.model-itemBoxs{
        margin-top: 10px;
    }
    .shareBox {
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;
        .cover {
            .imgBox, .img {
                width: 80px;
                height: 80px;
            }
        }
        .el-input, input{
            width: 400px !important;
        }
    }
    .formBox{
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;
        .cover {
            .imgBox, .img {
                width: 80px;
                height: 80px;
            }
        }
    }
    .btnBox {
        .el-form-item__content {
            margin-left: 0 !important;
        }
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
}
</style>
